import { useModals } from 'almanac-ui/Modal'
import { InlineFormatDropdownMenuItem } from 'components/InlineFormatBar/components/InlineFormatDropdownMenuItem/InlineFormatDropdownMenuItem'
import { EditorView } from 'prosemirror-view'
import React from 'react'
import { ArticleFlat } from 'types'
import { CreateNewPostModal } from '../CreateNewPost/CreateNewPostModal'
import { Send } from 'blaze-ui/icons/16'
import { usePaywallGuard } from 'hooks/usePaywallGuard'

export type TurnTextIntoDocInlineFormatButtonProps = {
  view: EditorView
  article: ArticleFlat
}

export const TurnTextIntoDocInlineFormatButton: React.FC<
  React.PropsWithChildren<TurnTextIntoDocInlineFormatButtonProps>
> = ({ view, article }) => {
  const { openModal } = useModals()

  const { channel, title } = article

  const guardedHandleTurnInto = usePaywallGuard(() =>
    openModal(CreateNewPostModal, { view, postTitle: title, articleChannel: channel }),
  )

  return (
    <InlineFormatDropdownMenuItem
      key="turn-into-doc"
      onPress={guardedHandleTurnInto}
      icon={<Send size={20} />}
      label="Cross Post"
    />
  )
}
